import type { CrowdexReferenceKind } from '@crowdex/agent-contracts';
import { ConversationHeader } from '@/components/desktop-shell/conversation-header';
import { EmbeddedConversation } from '@/components/embedded-conversation';
import type { CloudRuntime } from '@/lib/cloud-runtime/cloud-runtime';
import type { CachedConversation } from '@/lib/conversations/conversation-cache';
import type { NativeAgent } from '@/lib/native-desktop';

/**
 * A secondary conversation shown beside the active one: the whole conversation
 * (`EmbeddedConversation`) under its own header, with a button to make it the active one (the
 * side panel then shows its own) and one to close it.
 */
export function SplitConversationPane({
  agent,
  cloudRuntime,
  conversation,
  draft,
  onActivate,
  onClose,
  onConversationChange,
  onDraftChange,
  preview,
  resolveReference,
}: {
  agent: NativeAgent | null;
  cloudRuntime: CloudRuntime | null;
  conversation: CachedConversation;
  draft: string;
  onActivate: () => void;
  onClose: () => void;
  onConversationChange: (conversation: CachedConversation) => void;
  onDraftChange: (value: string) => void;
  preview: boolean;
  resolveReference: (kind: CrowdexReferenceKind, id: string) => Promise<unknown>;
}) {
  return (
    <EmbeddedConversation
      agent={agent}
      cloudRuntime={cloudRuntime}
      conversation={conversation}
      draft={draft}
      // The same header as the conversation the window runs (D56), for the other half.
      header={() => (
        <ConversationHeader
          conversationTitle={conversation.title}
          preview={preview}
          secondary={{
            conversationId: conversation.id,
            workspaceRoot: conversation.workspaceRoot,
            onActivate,
            onClose,
          }}
        />
      )}
      onConversationChange={onConversationChange}
      onDraftChange={onDraftChange}
      preview={preview}
      resolveReference={resolveReference}
    />
  );
}
